import GiftHero from '@/components/gift/Hero';
import GiftCardHeader from '@/components/giftCard/GiftCardHeader';
import HowItWorks from '@/components/giftCardV2/HowItWorks';
import { useRouterPush } from '@/hooks/utils/useRouterPush';

const GiftCardLayout = () => {
	const routerPush = useRouterPush();

	const goToGiftCardPurchase = async () => {
		await routerPush('/gift-card/purchase');
	};

	return (
		<>
			<GiftCardHeader isRedeem={false} handleCtaClick={goToGiftCardPurchase} isAnnual />
			<GiftHero handleCtaClick={goToGiftCardPurchase} isFullHeight />
			<HowItWorks />
		</>
	);
};

export default GiftCardLayout;
